<template>
    <div class="base-remind" :class="{'remind-sp': $store.state.screen == 1}">
        <div class="content">
            <div class="title">开启新服提醒</div>
            <div class="tips">系统将在新服开服前30分钟以消息推送方式通知您。为避免消息推送延时或失败，建议您开启微信提醒。</div>
            <div class="btn">
                <div class="item" @click="onOut">我知道了</div>
                <div class="item">开启微信提醒</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        methods: {
            onOut () {
                this.$emit('childRemind', false)
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../static/tctransition";
    $color: #FF6C22; // 主体颜色
    // 横屏css
    .base-remind {
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.8);
        transition: all 0.3s;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 999;
        .content {
            width: 840px;
            overflow: hidden;
            border-radius: 18px;
            background: $color;
            overflow: hidden;
            padding: 0 60px 60px;
            position: relative;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            .title {
                height: 160px;
                font-size: 51px;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .tips {
                font-size: 42px;
                margin-bottom: 50px;
            }
            .btn {
                height: 120px;
                margin-top: 55px;
                display: flex;
                justify-content: space-between;
                .item {
                    width: 345px;
                    height: 120px;
                    color: $color;
                    font-size: 39px;
                    border-radius: 18px;
                    background: #fff;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
                .item:first-child {
                    background: rgba(255, 255, 255, 0.8);
                }
            }
        }
    }
    // 竖屏css
    .remind-sp {
        .content {
            width: 1527px;
            border-radius: 32px;
            padding: 0 90px 90px;
            .title {
                height: 290px;
                font-size: 92px;
            }
            .tips {
                font-size: 76px;
                margin-bottom: 50px;
            }
            .btn {
                height: 200px;
                margin-top: 100px;
                .item {
                    width: 627px;
                    height: 200px;
                    font-size: 70px;
                    border-radius: 32px;
                }
            }
        }
    }
</style>